import { Tooltip } from "antd";
import { StarFilled } from "@ant-design/icons";
import { t } from "i18next";
import { PERMISSIONS, useUser } from "../../core/context/UserContext";

/**
 * Grid satırındaki yıldız: çekim, kullanıcının GÖRDÜĞÜ en az bir listedeyse çizilir.
 *
 * Veri satırla birlikte gelir (StudyTableItem.lists) — hover'da istek atılmaz.
 * Çekim birden çok listedeyse ikon TEKTİR, tooltip birikimlidir (liste adı + açıklama).
 *
 * Sunucu zaten yalnız görünür listelerin üyeliklerini gönderir; buradaki izin kontrolü ikinci
 * bir kapı: liste izinlerinden hiçbiri olmayan kullanıcıda ikon hiç çizilmez.
 */
export default function StudyListStar({ row }) {
    const { hasPermission } = useUser();

    const lists = row?.lists || [];

    if (lists.length === 0)
        return null;

    const canSee = hasPermission(PERMISSIONS.LIST_VIEW)
        || hasPermission(PERMISSIONS.LIST_VIEW_ALL)
        || hasPermission(PERMISSIONS.LIST_CREATE)
        || hasPermission(PERMISSIONS.LIST_ITEM_ADD);

    if (!canSee)
        return null;

    const title = (
        <div>
            {lists.map((x, idx) => (
                <div key={x.listId} style={{ marginBottom: idx === lists.length - 1 ? 0 : 4 }}>
                    <strong>{x.listName}</strong>
                    {x.description
                        ? <div style={{ fontSize: 11, color: '#ddd' }}>{x.description}</div>
                        : <div style={{ fontSize: 11, color: '#bbb', fontStyle: 'italic' }}>{t('No description')}</div>}
                </div>
            ))}
        </div>
    )

    return (
        <Tooltip title={title}>
            <StarFilled style={{ color: '#f1c40f' }} />
        </Tooltip>
    )
}
